import { Component, OnInit } from "@angular/core";
import { userTypesEnum } from "src/app/common/constants/common.constants";
import { Enterprise } from "src/app/common/models/admin.class";
import { AuthGuard } from "src/app/common/services/auth.service";
import { CommonService } from "src/app/common/services/common.service";
import { AdminService } from "src/app/modules/admin/services/admin.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"]
})
export class DashboardComponent implements OnInit {
  model: Enterprise = new Enterprise();
  userTypes = userTypesEnum;
  // Store authguard for template use if needed
  authguard: AuthGuard;

  constructor(
    private readonly _adminService: AdminService,
    private readonly _authguard: AuthGuard,
    private readonly _commonService: CommonService,
  ) {
    this.authguard = _authguard;
  }

  ngOnInit(): void {
    const enterpriseId = Number(this._commonService.getEnterpriseId());
    if (!isNaN(enterpriseId)) {
      this.getEnterprise(enterpriseId);
    }
  }

  /**
   * Fetches enterprise details by ID and updates the model.
   */
  getEnterprise(id: number): void {
    this._adminService.getEnterprise(id).subscribe({
      next: (res: Enterprise) => {
        this.model = res;
      },
      error: (err) => {
        // Handle error (show notification, log, etc.)
        console.error('Failed to fetch enterprise:', err);
      }
    });
  }

  /**
   * Triggers download of a bulk file. Handles DOM safely and errors.
   */
  download(isPackage: boolean): void {
    this._adminService.downloadBulkFile(isPackage).subscribe({
      next: (res: string) => {
        const filePath = res;
        const a = document.getElementById("btnDownload") as HTMLAnchorElement | null;
        if (a) {
          a.href = `${environment.apiUrl}${filePath}`;
          a.target = "_blank";
          a.download = this.model.name;
          a.click();
        } else {
          console.error('Download button not found');
        }
      },
      error: (err) => {
        // Handle error (show notification, log, etc.)
        console.error('Failed to download file:', err);
      }
    });
  }
}
